import { gql } from '@apollo/client';

/**
 * A Query despite minting a presigned PUT — that is the existing schema shape,
 * so it is issued via `client.query`, not `useMutation`.
 */
export const GET_KB_DOCUMENT_UPLOAD_URL_QUERY = gql`
  query GetKbDocumentUploadUrl($input: GetKbDocumentUploadUrlInput!) {
    getKbDocumentUploadUrl(input: $input) {
      statusCode
      message
      uploadUrl
      s3Key
      contentType
      expiresIn
    }
  }
`;
